export default __webpack_public_path__ + "static/media/satoshi.41e209f5.svg";